/**
 * bundle-quantity.js
 */

/* ============================================================
   1. bundle-quantity-counter custom element
   ============================================================ */

class BundleQuantityCounter extends HTMLElement {
  connectedCallback() {
    this._sectionId = this.dataset.sectionId;
    this._max       = parseInt(this.dataset.bundleMax, 10) || 12;
    this._currentEl = this.querySelector('[data-bundle-current]');
    this._barEl     = this.querySelector('[data-bundle-bar]');

    this._onChange = (e) => {
      if (e.target.matches('[data-bundle-qty]') &&
          e.target.dataset.sectionId === this._sectionId) {
        this._update();
      }
    };
    document.addEventListener('change', this._onChange);
    this._update();
  }

  disconnectedCallback() {
    document.removeEventListener('change', this._onChange);
  }

  _selects() {
    return document.querySelectorAll(
      `[data-bundle-qty][data-section-id="${this._sectionId}"]`
    );
  }

  total() {
    let t = 0;
    this._selects().forEach(s => { t += parseInt(s.value, 10) || 0; });
    return t;
  }

  _update() {
    const total  = this.total();
    const capped = Math.min(total, this._max);
    const pct    = Math.min((capped / this._max) * 100, 100);
    if (this._currentEl) this._currentEl.textContent = capped;
    if (this._barEl)     this._barEl.style.width = `${pct}%`;
    this.classList.toggle('bundle-counter--full',  total >= this._max);
    this.classList.toggle('bundle-counter--over',  total >  this._max);
    this.classList.toggle('bundle-counter--empty', total === 0);
  }
}

customElements.define('bundle-quantity-counter', BundleQuantityCounter);

/* ============================================================
   2. Over-limit guard
   ============================================================ */

document.addEventListener('change', (e) => {
  const select = e.target.closest('[data-bundle-qty]');
  if (!select) return;
  const sectionId = select.dataset.sectionId;
  const max       = parseInt(select.dataset.bundleMax, 10) || 12;
  const counter   = document.querySelector(
    `bundle-quantity-counter[data-section-id="${sectionId}"]`
  );
  if (!counter) return;
  const total = counter.total();
  if (total > max) {
    const overage = total - max;
    const current = parseInt(select.value, 10) || 0;
    select.value  = Math.max(0, current - overage).toString();
    counter._update();
  }
});

/* ============================================================
   3. Bundle helpers
   ============================================================ */

function getBundleItems() {
  const items = [];
  document.querySelectorAll('[data-bundle-qty]').forEach((sel) => {
    const qty = parseInt(sel.value, 10) || 0;
    if (qty > 0) {
      items.push({
        id: parseInt(sel.dataset.variantId, 10),
        quantity: qty
      });
    }
  });
  return items;
}

async function addBundleItemsToCart(items) {
  if (!items.length) return;
  console.log('[bundle-quantity] Adding bundle items:', items);
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.description || 'Could not add bundle items.');
  }
  return res.json();
}

/* ============================================================
   4. Intercept the Add to Cart button click directly
   We use capture:true so we fire before Concept's listeners.
   We let Concept's submission happen normally, then add bundle
   items straight after via a separate cart API call.
   ============================================================ */

function initBundleIntercept() {
  const addButtons = document.querySelectorAll(
    '[type="submit"][name="add"][form]'
  );

  addButtons.forEach((btn) => {
    btn.addEventListener('click', async (e) => {
      const bundleItems = getBundleItems();
      if (!bundleItems.length) return; // nothing to add, proceed normally

      // Let Concept's click handler fire and submit the main product
      // Then wait briefly for it to complete before adding bundle items
      setTimeout(async () => {
        try {
          await addBundleItemsToCart(bundleItems);
      console.log('[bundle-quantity] Bundle items added successfully');

          // Fetch updated cart
          const cartRes = await fetch('/cart.js');
          const cart    = await cartRes.json();

          // Update cart count in header
          document.querySelectorAll(
            '.cart-count, [data-cart-count], .cart__count, .header__cart-count'
          ).forEach(el => { el.textContent = cart.item_count; });

          // Re-render the cart drawer with fresh section HTML
          const cartDrawer = document.querySelector('cart-drawer');
if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
  cartDrawer.renderContents({ detail: { cart } });
} else {
  document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
}

        } catch (err) {
          console.error('[bundle-quantity] Failed to add bundle items:', err);
        }
      }, 1500); // 1500ms gives Concept time to complete its own cart add

    }, false);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBundleIntercept);
} else {
  initBundleIntercept();
}